// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var Selection__InputSelection$SmartcutsMacros = require("./Selection__InputSelection.bs.js");
var Selection__NonInputSelection$SmartcutsMacros = require("./Selection__NonInputSelection.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(encoder_domElementRepresentation, v) {
  if (v.TAG === /* NonInputSelection */0) {
    return [
            "NonInputSelection",
            Selection__NonInputSelection$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._0)
          ];
  } else {
    return [
            "InputSelection",
            Selection__InputSelection$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._0)
          ];
  }
}

function t_decode(decoder_domElementRepresentation, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "InputSelection" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Selection__InputSelection$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputSelection */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NonInputSelection" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Selection__NonInputSelection$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NonInputSelection */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function extractTexts(selection) {
  if (selection.TAG === /* NonInputSelection */0) {
    return Selection__NonInputSelection$SmartcutsMacros.Generic.extractTexts(selection._0);
  } else {
    return Selection__InputSelection$SmartcutsMacros.Generic.extractTexts(selection._0);
  }
}

function extractSelectors(selectorFromDomElementRepresentation, selection) {
  if (selection.TAG !== /* NonInputSelection */0) {
    return [Curry._1(selectorFromDomElementRepresentation, selection._0.domElementRepresentation)];
  }
  var func = Selection__NonInputSelection$SmartcutsMacros.Generic.extractSelectors;
  return Curry._2(func, selectorFromDomElementRepresentation, selection._0);
}

function stringify(stringifyDomElementRepresentation, strictSelection) {
  if (strictSelection.TAG === /* NonInputSelection */0) {
    return "NonInputSelection(" + (Selection__NonInputSelection$SmartcutsMacros.Generic.stringify(stringifyDomElementRepresentation, strictSelection._0) + ")");
  } else {
    return "InputSelection(" + (Selection__InputSelection$SmartcutsMacros.Generic.stringify(stringifyDomElementRepresentation, strictSelection._0) + ")");
  }
}

var Generic = {
  t_encode: t_encode,
  t_decode: t_decode,
  extractTexts: extractTexts,
  extractSelectors: extractSelectors,
  stringify: stringify
};

function t_encode$1(v) {
  return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$1(v) {
  return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function stringify$1(param) {
  return stringify(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify, param);
}

function fromDomSelection(domElementIdentifierGenerator, domSelection) {
  var strictSelection = Selection__NonInputSelection$SmartcutsMacros.ForRecording.fromDomSelection(domElementIdentifierGenerator, domSelection);
  return {
          TAG: /* NonInputSelection */0,
          _0: strictSelection
        };
}

function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
  var strictSelection = Selection__NonInputSelection$SmartcutsMacros.ForRecording.fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot);
  return {
          TAG: /* NonInputSelection */0,
          _0: strictSelection
        };
}

function actsOnSameNodeAsOtherSelection(selectionA, selectionB) {
  if (selectionA.TAG === /* NonInputSelection */0) {
    if (selectionB.TAG === /* NonInputSelection */0) {
      return Selection__NonInputSelection$SmartcutsMacros.ForRecording.actsOnSameNodeAsOtherSelection(selectionA._0, selectionB._0);
    } else {
      return false;
    }
  } else if (selectionB.TAG === /* NonInputSelection */0) {
    return false;
  } else {
    return Selection__InputSelection$SmartcutsMacros.ForRecording.actsOnSameNodeAsOtherSelection(selectionA._0, selectionB._0);
  }
}

function endsOnNode(node, selection) {
  if (selection.TAG === /* NonInputSelection */0) {
    return Selection__NonInputSelection$SmartcutsMacros.ForRecording.endsOnNode(node, selection._0);
  } else {
    return Selection__InputSelection$SmartcutsMacros.ForRecording.actsOnNode(node, selection._0);
  }
}

function fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement) {
  var inputSelection = Selection__InputSelection$SmartcutsMacros.ForRecording.fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement);
  return {
          TAG: /* InputSelection */1,
          _0: inputSelection
        };
}

function extractSelectors$1(param) {
  return extractSelectors((function (param) {
                return param.selector;
              }), param);
}

var ForRecording = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  fromDomSelection: fromDomSelection,
  fromSelectionSnapshot: fromSelectionSnapshot,
  actsOnSameNodeAsOtherSelection: actsOnSameNodeAsOtherSelection,
  endsOnNode: endsOnNode,
  fromHtmlInputElement: fromHtmlInputElement,
  extractSelectors: extractSelectors$1
};

function t_encode$2(v) {
  return t_encode(Selector$SmartcutsMacros.selector_encode, v);
}

function t_decode$2(v) {
  return t_decode(Selector$SmartcutsMacros.selector_decode, v);
}

function fromRecording(selection) {
  if (selection.TAG === /* NonInputSelection */0) {
    return {
            TAG: /* NonInputSelection */0,
            _0: Selection__NonInputSelection$SmartcutsMacros.ForNonRecording.fromRecording(selection._0)
          };
  } else {
    return {
            TAG: /* InputSelection */1,
            _0: Selection__InputSelection$SmartcutsMacros.ForNonRecording.fromRecording(selection._0)
          };
  }
}

function updateSelector(f, selection) {
  if (selection.TAG === /* NonInputSelection */0) {
    return {
            TAG: /* NonInputSelection */0,
            _0: Selection__NonInputSelection$SmartcutsMacros.ForNonRecording.updateSelector(f, selection._0)
          };
  } else {
    return {
            TAG: /* InputSelection */1,
            _0: Selection__InputSelection$SmartcutsMacros.ForNonRecording.updateSelector(f, selection._0)
          };
  }
}

function extractSelectors$2(param) {
  return extractSelectors((function (selector) {
                return selector;
              }), param);
}

function getSelectedText(selection) {
  if (selection.TAG === /* NonInputSelection */0) {
    return Selection__NonInputSelection$SmartcutsMacros.Generic.extractTexts(selection._0)[1];
  } else {
    return Selection__InputSelection$SmartcutsMacros.Generic.extractTexts(selection._0)[1];
  }
}

var ForNonRecording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromRecording: fromRecording,
  updateSelector: updateSelector,
  extractSelectors: extractSelectors$2,
  getSelectedText: getSelectedText
};

var SelectionSnapshot;

var NonInputSelection;

var InputSelection;

exports.SelectionSnapshot = SelectionSnapshot;
exports.NonInputSelection = NonInputSelection;
exports.InputSelection = InputSelection;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording;
/* Selector-SmartcutsMacros Not a pure module */
